import axios from '@/services/servicio-base';

const servicioCuenta = {};

servicioCuenta.cambiarPassword = function(passwordAnterior, passwordNuevo) {
   return axios.post('/cuenta/cambiar-password', {passwordAnterior, passwordNuevo})
   .then(r => {
      return r.data;
   })
   .catch(e => {
      return e;
   })
}

export default servicioCuenta;